import React from 'react';
import { Link } from 'react-router-dom';
import styles from './RecruitmentBanner.module.css';

const RecruitmentBanner: React.FC = () => {
  return (
    <section className={styles.recruitmentBanner}>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: 'url(/images/inspector-background.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.15,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.badge}>직원모집</div>
          <h2 className={styles.title}>
            검사원 모집
          </h2>
          <p className={styles.description}>
            승강기 검사원을 모집합니다. 자격요건을 확인하시고 지원해주세요.
          </p>
          <div className={styles.contactInfo}>
            <div className={styles.contactItem}>
              <img src="/images/icon-email.svg" alt="이메일" className={styles.icon} />
              <a href="mailto:kesti2026@daum.net" className={styles.contactLink}>
                kesti2026@daum.net
              </a>
            </div>
            <div className={styles.contactItem}>
              <img src="/images/icon-phone.svg" alt="전화" className={styles.icon} />
              <a href="tel:010-5142-6867" className={styles.contactLink}>
                  010-5142-6867
              </a>
            </div>
          </div>
          <Link to="/recruitment" className={styles.detailButton}>
            자세히 보기
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentBanner;
